import { render, staticRenderFns } from "./DebugPanel.vue?vue&type=template&id=a35543e0&scoped=true&"
import script from "./DebugPanel.vue?vue&type=script&lang=js&"
export * from "./DebugPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35543e0",
  null
  
)

export default component.exports